/* This is the EMIS ethnic for secondary school components */
<template>
	<v-container>
		<div>
			<span v-html="title"></span>
		</div>
		<div>
			<table style="height: 72px;" border="1px;" width="850" cellspacing="0px;">
				<tbody>
					<tr>
						<td style="width: 130px; height: 25px; text-align: center; vertical-align: middle;" rowspan="2">
							ជនជាតិដើមភាគតិចតាមក្រុមអាយុ 
						</td>
						<td class="row-header" colspan="2">ថ្នាក់ទី ៧</td>
						<td class="row-header" colspan="2">ថ្នាក់ទី ៨</td>
						<td class="row-header" colspan="2">ថ្នាក់ទី ៩</td>
						<td style="width: 130px; height: 25px; text-align: center; vertical-align: middle;" rowspan="2">
							ជនជាតិដើមភាគតិចតាមក្រុមអាយុ
						</td>
						<td class="row-header" colspan="2">ថ្នាក់ទី ១០</td>
						<td class="row-header" colspan="2">ថ្នាក់ទី ១១</td>
						<td class="row-header" colspan="2">ថ្នាក់ទី ១២</td>
					</tr>
					<tr>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
					</tr>
					<!-- The first 3 row -->
					<tr v-for="(value, row) in ethLow.length - 2" :key="row">
						<!-- Lower Secondary columns input -->
						<td class="row-title">{{ethLow[row]}}</td>
						<td v-for="(value, col) in ethlow[row].dt.length" :key="'l' + col" class="row-data">
							<numberinput v-model="ethlow[row].dt[col]" class="number"/>
						</td>
						<!-- Upper Secondary columns input -->
						<td class="row-title">{{ethHig[row]}}</td>
						<td v-for="(value1, col) in ethhigh[row].dt.length" :key="'h' + col" class="row-data">
							<numberinput v-model="ethhigh[row].dt[col]" class="number"/>
						</td>
					</tr>
					<!-- The last two row -->
					<tr v-for="(value, row) in 2" :key="'v' + row">
						<!-- Lower secondary part -->
						<td class="row-title">{{ethLow[row+3]}}</td>
						<td class="row-data">សរុប</td>
						<td class="row-data-long" colspan="2">
							<numberinput v-model="tente[row].dt[0]" class="number-long"/>
						</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data-long" colspan="2">
							<numberinput v-model="tente[row].dt[1]" class="number-long"/>
						</td>
						<!-- Upper secondary part -->
						<td class="row-title">{{ethLow[row+3]}}</td>
						<td class="row-data">សរុប</td>
						<td class="row-data-long" colspan="2">
							<numberinput v-model="tente[row].dt[2]" class="number-long"/>
						</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data-long" colspan="2">
							<numberinput v-model="tente[row].dt[3]" class="number-long"/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</v-container>
</template>

<script>
import NumberInput from '@/components/common/NumberInput.vue'
import { ethLow, ethHig } from '@/utils/ascf/secConfig.js'
export default {
	props: ["ethlow", "ethhigh", "tente", "title"],
	components: {
    'numberinput': NumberInput
  },
	data() {
    return {
			ethLow: ethLow,
			ethHig: ethHig
    }
	}
}
</script>

<style scoped>
  .number {
		width:45px;
		text-align: center;
  }
	.number-long {
		width:90px;
		text-align: center;
  }
  .row-data {
    width: 45px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
	.row-data-long {
    width: 90px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
	.row-title {
    width: 130px;
    height: 25px;
    text-align:left;
    vertical-align: middle;
  }
  .row-header {
    width: 90px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
</style>